<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content>
  <form class="edit-report-source-dialog-form">
    <mat-form-field>
      <mat-label>Widget Name</mat-label>
      <input matInput name="embedName" [(ngModel)]="embedName" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Subscription</mat-label>
      <mat-select name="subscriptionId" [(ngModel)]="subscriptionId">
        <mat-option *ngFor="let subscription of subscriptions" [value]="subscription.subscriptionId">{{ subscription.subscriptionName + ' [' + subscription.organizationName + ']' }}</mat-option>
      </mat-select>
    </mat-form-field><br />
    <!--<mat-form-field>
      <mat-label>Pre-Filter</mat-label>
      <mat-select name="preFilterId" [(ngModel)]="preFilterId">
        <mat-option [value]="-1">Default Pre-Filter</mat-option>
        <mat-option *ngFor="let preFilter of preFilters" [value]="preFilter.preFilterId">{{ preFilter.name }}</mat-option>
      </mat-select>
    </mat-form-field><br />-->
    <mat-form-field>
      <mat-label>Select Widget Page</mat-label>
      <mat-select name="selectedReportPage" [(ngModel)]="selectedReportPage">
        <mat-option *ngFor="let reportPage of availablePages" [value]="reportPage">{{ reportPage }}</mat-option>
      </mat-select>
    </mat-form-field><br />
    <ng-container>
      <mat-checkbox name="disabled" [(ngModel)]="disabled">Disable Embed?</mat-checkbox>
    </ng-container>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-raised-button
          class="piButton"
          (click)="onConfirmClick()"
          cdkFocusInitial>
    Confirm
  </button>
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
</div>
